module.exports = {
  DECODE_SECURITY_TOKEN: 'DECODE_SECURITY_TOKEN',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  SET_LOGGED_IN: 'SET_LOGGEDIN_IN',
};
